/**
 * SYS-17 «Стартовая последовательность» и SYS-02 «Сервис недоступен».
 */
import { Button, Icon, LogoTile, Spinner } from '@shared/ui'

import styles from './system.module.css'

export function BootScreen({ error }: { error?: string | null }): React.ReactElement {
  if (error) {
    return (
      <div className={styles['centered']}>
        <span className={styles['icon']}>
          <Icon name="alert" size={30} />
        </span>

        <div className={styles['title']}>Сервис недоступен</div>
        <p className={styles['text']}>{error}</p>

        <Button variant="primary" onClick={() => location.reload()}>
          Повторить
        </Button>
      </div>
    )
  }

  return (
    <div className={styles['centered']}>
      <LogoTile size={64} />
      <Spinner size={22} label="Загрузка" />
    </div>
  )
}
